export default __webpack_public_path__ + "static/logo-eb4fa04593f5343b177825d550586b6a.svg";